export const canShowEarnings = (user) => {
  return (
    user?.role?.roleName?.toLowerCase() === "agent" ||
    (user?.role?.roleName?.toLowerCase() === "agent assistant" &&
      user?.viewCommissions === 1)
  );
};
